import config from '@/config/config';
import Storage from '@/service/Storage';

export default {
  reset: (state) => {
    state.isLoading = false;
    state.token = null;
    state.course = {};
    state.exam = {};
    state.answers = [];
    state.examResults = {};
    state.errors = [];
    state.current = config.initial.course.start;
    Storage.removeItem('token');
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  setToken: (state, token) => {
    state.token = token;
    Storage.setItem('token', token);
  },
  setCurrentCourse: (state, currentCourse) => {
    state.currentCourse = currentCourse;
  },
  setCurrentLectureIndex: (state, currentLectureIndex) => {
    state.currentLectureIndex = currentLectureIndex;
  },
  setResponse: (state, response) => {
    state.isLoading = false;
    state.course = response || {};
    state.errors = [];
    state.current = config.initial.course.start;
    state.exam = {};
    state.answers = [];
    state.examResults = {};
  },
  setExam: (state, response) => {
    state.isLoading = false;
    state.exam = response || {};
    state.answers = [];
    state.examResults = {};
  },
  addError: (state, error) => {
    state.errors.push(error);
  },
  addAnswer: (state, answer) => {
    state.answers.push(answer);
  },
  setCurrent: (state, current) => {
    state.current = current;
  },
  setExamResults: (state, results) => {
    state.examResults = results;
  },
  resetExam: (state) => {
    state.exam = {};
    state.answers = [];
    state.examResults = {};
  },
};
